// import Dashboard from "../components/Dashboard/Dashboard";
import React from "react";
import Movie from "../components/Movie/Movie/Movie";
import MastersModule from "../modules/MastersModule";
import { useSelector } from "react-redux";
import EpisodeDetail from "../components/WebSeries/Episode/EpisodeDetail.jsx";
const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard.jsx"));
const Distributor = React.lazy(() => import("../modules/DistributorsModule"));
const Series = React.lazy(() =>
  import("../components/WebSeries/Series/Series")
);
const Season = React.lazy(() =>
  import("../components/WebSeries/Season/Season")
);
const Episode = React.lazy(() =>
  import("../components/WebSeries/Episode/Episode")
);
const Slider = React.lazy(() =>
  import("../components/SliderBanner/SliderBanner")
);
const LoginSlider = React.lazy(() =>
  import("../components/SliderBanner/LoginBanner")
);
// const Subscription = React.lazy(() =>
//   import("../components/Subscription/Subscriptions")
// );
const Promotion = React.lazy(() => import("../components/Promotion/Promotion"));

const PlanSubscriptions = React.lazy(() => import("../components/Subscription/PlanSubscriptions"))
const CoinSubscription = React.lazy(() => import("../components/Subscription/CoinSubscription"))

const SettingModule = React.lazy(() => import("../modules/SettingModule"));
// const MovieDetailsModule = React.lazy(() =>
//   import("../components/MovieDetails/MovieDetails")
// )
const Customer = React.lazy(() => import("../components/Customer/Customer.jsx"));

const AdminContentForm = React.lazy(() =>
  import("../components/Distributor/ContentForm")
);
const ComingSoon = React.lazy(() =>
  import("../components/ComingSoon/ComingSoon")
);
const Song = React.lazy(() => import("../components/Song/Song"));
const SongSlider = React.lazy(() =>
  import("../components/SliderBanner/SongSliderBanner")
);
const Notification = React.lazy(() =>
  import("../components/Notification/Notification.jsx")
);
const MovieDetail = React.lazy(() =>
  import("../components/Movie/MovieDetail/ProductDetailsContent")
);
const CustomerDetail = React.lazy(() =>
  import("../components/CustomerDetail/CustomerDetail.jsx")
);
const SeriesDetail = React.lazy(() =>
  import("../components/SeriesDetails/NewSeries")
);
const Transaction = React.lazy(() =>
  import("../components/Transaction/Transaction")
);
const Analytics = React.lazy(() => import("../components/Analytics/Analytics.jsx"));
const Complaints = React.lazy(() =>
  import("../components/Complaint/Complaint")
);
const SongDetail = React.lazy(() =>
  import("../components/Song/SongDetail/SongDetailsContent")
);


const Promocode = React.lazy(() => import("../components/Coupon/Coupon"));
const PromocodeDetail = React.lazy(() =>
  import("../components/Coupon/CouponHistory")
);
const TopTenVideos = React?.lazy(() =>
  import("../components/TopTenMovie/TopTenMovie")
);
const LeavingSoon = React.lazy(()=>
  import("../components/ContentLeaving/ContentLeaving")
)
const DistributorDitails = React.lazy(()=>
  import("../components/Distributor/DistributorInfo/DistributorInfo")
)
const Offers = React.lazy(() =>
  import("../components/Offers/Offers")
)
const Highlight = React.lazy(() =>
  import("../components/Highlight/Highlight")
)
const AdBanner = React.lazy(() =>
  import("../components/AdBanner/AdBanner")
)
const PlayStoreContent = React.lazy(() => 
  import("../components/Movie/PlayStoreContent/PlayStoreContent")
)
const PlatStoreSlider = React.lazy(() => 
  import("../components/SliderBanner/PlaystoreSlider")
)

export const usePrivateRoutes = () => {
  const reduxRole = useSelector((state) => state.layout.role);
  const loginedDetails = JSON.parse(sessionStorage.getItem("loggedInDetails"));
  const role = reduxRole || loginedDetails?.role;
  console.log(role, "fgsaaaaaaa");

  // if (role == "Admin") {
    return [
      {
        path: `/Dashboard`,
        Component: <Dashboard />,
      },
      {
        path: `/movie`,
        Component: <Movie />,
      },
      {
        path: `/comingsoon`,
        Component: <ComingSoon />,
      },
      {
        path: `/movie/detail`,
        Component: <MovieDetail />,
      },
      {
        path: `/song`,
        Component: <Song />,
      },
      {
        path: `/song/detail`,
        Component: <SongDetail />,
      },
      {
        path: `/series`,
        Component: <Series />,
      },
      {
        path: `/series/detail`,
        Component: <SeriesDetail />,
      },
      {
        path: `/series/detail/episode-detail`,
        Component: <EpisodeDetail  />,
      },
      {
        path: `/season`,
        Component: <Season />,
      },
      {
        path: `/episode`,
        Component: <Episode />,
      },
      // {
      //   path: `/episode/detail`,
      //   Component: <EpisodeDetail />,
      // },
      {
        path: `/slider/banner`,
        Component: <Slider />,
      },
      {
        path: `/slider/login`,
        Component: <LoginSlider />,
      },
      {
        path: `/customer`,
        Component: <Customer />,
      },
      {
        path: `/analytics`,
        Component: <Analytics />,
      },
      {
        path: `/customer/detail`,
        Component: <CustomerDetail />,
      },
      
      {
        path: `/subscription/plan`,
        Component: <PlanSubscriptions />,
      },
      {
        path: `/subscription/coin-plan`,
        Component: <CoinSubscription />,
      },
      {
        path: `/promotion`,
        Component: <Promotion />,
      },
      {
        path: `/songslider`,
        Component: <SongSlider />,
      },
      {
        path: `/notification`,
        Component: <Notification />,
      },
      {
        path: `/transaction`,
        Component: <Transaction />,
      },
      {
        path: `/master/*`,
        Component: <MastersModule />,
      },
      {
        path: `/distributor/*`,
        Component: <Distributor />,
      },
      {
        path: `/complaints/*`,
        Component: <Complaints />,
      },
      {
        path: `/contentform`,
        Component: <AdminContentForm />,
      },
      {
        path: `/promocode`,
        Component: <Promocode />,
      },
      {
        path: `/toptenvideos`,
        Component: <TopTenVideos />,
      },
      {
        path: `/leavingsoon`,
        Component: <LeavingSoon />,
      },
      {
        path: `/promocode/detail`,
        Component: <PromocodeDetail />,
      },
      {
        path: `/distributor/detail`,
        Component: <DistributorDitails />,
      },
      {
        path: `/setting/*`,
        Component: <SettingModule />,
      },
      {
        path: `/Offers`,
        Component: <Offers />,
      },
      {
        path: `/highlight`,
        Component: <Highlight />,
      },
      {
        path: `/adbanner`,
        Component: <AdBanner />,
      },
      {
        path: `/playstorecontent`,
        Component: <PlayStoreContent />,
      },
      {
        path: `/playstoreslider`,
        Component: <PlatStoreSlider />,
      },
    ];
  }
  //  else
  //    {
  //   return [
  //     {
  //       path: `/Dashboard`,
  //       Component: <DistributorDashboard />,
  //     },
  //     {
  //       path: `/contentform`,
  //       Component: <ContentForm />,
  //     },
  //     {
  //       path: `/movies`,
  //       Component: <DistributorMovies />,
  //     },
  //     {
  //       path: `/movies/detail`,
  //       Component: <MovieDetail />,
  //     },
  //     {
  //       path: `/series`,
  //       Component: <DistributorSeries />,
  //     },
  //     {
  //       path: `/series/detail`,
  //       Component: <SeriesDetail />,
  //     },
  //     {
  //       path: `/song`,
  //       Component: <DistributorSong />,
  //     },
  //     {
  //       path: `/song/detail`,
  //       Component: <SongDetail />,
  //     },
  //     {
  //       path: `/notification`,
  //       Component: <DistributorNotification />,
  //     },
  //     {
  //       path: `/distributorcoupon`,
  //       Component: <DistributorCoupon />,
  //     },
  //   ];
  // }
// };
